'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var debug = require('debug');

var _require = require('multiformats/hashes/sha2'),
    sha256 = _require.sha256;

var _require2 = require('multiformats/bases/base58'),
    base58btc = _require2.base58btc;

var _require3 = require('interface-datastore/key'),
    Key = _require3.Key;

var _require4 = require('uint8arrays/xor'),
    uint8ArrayXor = _require4.xor;

var _require5 = require('uint8arrays/compare'),
    uint8ArrayCompare = _require5.compare;

var pMap = require('p-map');

var _require6 = require('libp2p-record'),
    Record = _require6.Record;

var PeerId = require('peer-id');

var errcode = require('err-code');

var _require7 = require('uint8arrays/from-string'),
    uint8ArrayFromString = _require7.fromString;

var _require8 = require('uint8arrays/to-string'),
    uint8ArrayToString = _require8.toString;

var _require9 = require('uint8arrays/concat'),
    uint8ArrayConcat = _require9.concat;

var pTimeout = require('p-timeout');
/**
 * Creates a DHT ID by hashing a given Uint8Array.
 *
 * @param {Uint8Array} buf
 * @returns {Promise<Uint8Array>}
 */


exports.convertBuffer = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(buf) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return sha256.digest(buf);

          case 2:
            return _context.abrupt("return", _context.sent.digest);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Creates a DHT ID by hashing a Peer ID
 *
 * @param {PeerId} peer
 * @returns {Promise<Uint8Array>}
 */


exports.convertPeerId = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return sha256.digest(peer.id);

          case 2:
            return _context2.abrupt("return", _context2.sent.digest);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Convert a Uint8Array to their SHA2-256 hash.
 *
 * @param {Uint8Array} buf
 * @returns {Key}
 */


exports.bufferToKey = function (buf) {
  return new Key('/' + exports.encodeBase32(buf), false);
};
/**
 * Generate the key for a public key.
 *
 * @param {PeerId} peer
 * @returns {Uint8Array}
 */


exports.keyForPublicKey = function (peer) {
  return uint8ArrayConcat([uint8ArrayFromString('/pk/'), peer.id]);
};
/**
 * @param {Uint8Array} key
 */


exports.isPublicKeyKey = function (key) {
  return uint8ArrayToString(key.slice(0, 4)) === '/pk/';
};
/**
 * @param {Uint8Array} key
 */


exports.fromPublicKeyKey = function (key) {
  return new PeerId(key.slice(4));
};
/**
 * Get the current time as timestamp.
 *
 * @returns {number}
 */


exports.now = function () {
  return Date.now();
};
/**
 * Encode a given Uint8Array into a base32 string.
 *
 * @param {Uint8Array} buf
 * @returns {string}
 */


exports.encodeBase32 = function (buf) {
  return uint8ArrayToString(buf, 'base32');
};
/**
 * Decode a given base32 string into a Uint8Array.
 *
 * @param {string} raw
 * @returns {Uint8Array}
 */


exports.decodeBase32 = function (raw) {
  return uint8ArrayFromString(raw, 'base32');
};
/**
 * Sort peers by distance to the given `target`.
 *
 * @param {Array<PeerId>} peers
 * @param {Uint8Array} target
 */


exports.sortClosestPeers = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peers, target) {
    var distances;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return pMap(peers, /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peer) {
                var id;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return exports.convertPeerId(peer);

                      case 2:
                        id = _context3.sent;
                        return _context3.abrupt("return", {
                          peer: peer,
                          distance: uint8ArrayXor(id, target)
                        });

                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x5) {
                return _ref4.apply(this, arguments);
              };
            }());

          case 2:
            distances = _context4.sent;
            return _context4.abrupt("return", distances.sort(exports.xorCompare).map(function (d) {
              return d.peer;
            }));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Compare function to sort an array of elements which have a distance property which is the xor distance to a given element.
 *
 * @param {{ distance: Uint8Array }} a
 * @param {{ distance: Uint8Array }} b
 */


exports.xorCompare = function (a, b) {
  return uint8ArrayCompare(a.distance, b.distance);
};
/**
 * Computes how many results to collect on each disjoint path, rounding up.
 * This ensures that we look for at least one result per path.
 *
 * @param {number} resultsWanted
 * @param {number} numPaths - total number of paths
 */


exports.pathSize = function (resultsWanted, numPaths) {
  return Math.ceil(resultsWanted / numPaths);
};
/**
 * Create a new put record, encodes and signs it if enabled.
 *
 * @param {Uint8Array} key
 * @param {Uint8Array} value
 * @returns {Uint8Array}
 */


exports.createPutRecord = function (key, value) {
  var timeReceived = new Date();
  var rec = new Record(key, value, timeReceived);
  return rec.serialize();
};
/**
 * Creates a logger for the given subsystem
 *
 * @param {PeerId} [id]
 * @param {string} [subsystem]
 */


exports.logger = function (id, subsystem) {
  var name = ['libp2p', 'dht'];

  if (subsystem) {
    name.push(subsystem);
  }

  if (id) {
    name.push("".concat(id.toB58String().slice(0, 8)));
  } // Add a formatter for converting to a base58 string


  debug.formatters.b = function (v) {
    return base58btc.baseEncode(v);
  };

  var logger = Object.assign(debug(name.join(':')), {
    error: debug(name.concat(['error']).join(':'))
  });
  return logger;
};

exports.TimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(TimeoutError, _Error);

  var _super = _createSuper(TimeoutError);

  function TimeoutError() {
    _classCallCheck(this, TimeoutError);

    return _super.apply(this, arguments);
  }

  _createClass(TimeoutError, [{
    key: "code",
    get: function get() {
      return 'ETIMEDOUT';
    }
  }]);

  return TimeoutError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Creates an async function that calls the given `asyncFn` and Errors
 * if it does not resolve within `time` ms
 *
 * @template T
 * @param {(...args: any[]) => Promise<T>} asyncFn
 * @param {number} [time]
 */


exports.withTimeout = function (asyncFn, time) {
  /**
   * @param  {...any} args
   * @returns {Promise<T>}
   */
  function timeoutFn() {
    return _timeoutFn.apply(this, arguments);
  }

  function _timeoutFn() {
    _timeoutFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var res,
          _args5 = arguments;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (time) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return", asyncFn.apply(void 0, _args5));

            case 2:
              _context5.prev = 2;
              _context5.next = 5;
              return pTimeout(asyncFn.apply(void 0, _args5), time);

            case 5:
              res = _context5.sent;
              _context5.next = 13;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](2);

              if (!(_context5.t0 instanceof pTimeout.TimeoutError)) {
                _context5.next = 12;
                break;
              }

              throw errcode(_context5.t0, 'ETIMEDOUT');

            case 12:
              throw _context5.t0;

            case 13:
              return _context5.abrupt("return", res);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 8]]);
    }));
    return _timeoutFn.apply(this, arguments);
  }

  return timeoutFn;
};
/**
 * Iterates the given `asyncIterator` and runs each item through the given `asyncFn` in parallel.
 * Returns a promise that resolves when all items of the `asyncIterator` have been passed
 * through `asyncFn`.
 *
 * @template T
 * @template O
 *
 * @param {AsyncIterable<T>} asyncIterator
 * @param {(arg0: T) => Promise<O>} asyncFn
 */


exports.mapParallel = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(asyncIterator, asyncFn) {
    var tasks, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            tasks = [];
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context6.prev = 3;
            _iterator = _asyncIterator(asyncIterator);

          case 5:
            _context6.next = 7;
            return _iterator.next();

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context6.sent).done)) {
              _context6.next = 13;
              break;
            }

            item = _step.value;
            tasks.push(asyncFn(item));

          case 10:
            _iteratorAbruptCompletion = false;
            _context6.next = 5;
            break;

          case 13:
            _context6.next = 19;
            break;

          case 15:
            _context6.prev = 15;
            _context6.t0 = _context6["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context6.t0;

          case 19:
            _context6.prev = 19;
            _context6.prev = 20;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context6.next = 24;
              break;
            }

            _context6.next = 24;
            return _iterator.return();

          case 24:
            _context6.prev = 24;

            if (!_didIteratorError) {
              _context6.next = 27;
              break;
            }

            throw _iteratorError;

          case 27:
            return _context6.finish(24);

          case 28:
            return _context6.finish(19);

          case 29:
            return _context6.abrupt("return", Promise.all(tasks));

          case 30:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[3, 15, 19, 29], [20,, 24, 28]]);
  }));

  return function (_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();